import { ReactNode } from "react"

import { classNames } from "lib/classNames"

export type StepCardProps = {
  title: string
  children: ReactNode
}

export function StepCard({
  className,
  children,
}: {
  className?: string
  children: ReactNode
}) {
  return (
    <div
      className={classNames(
        "bg-elevation-surface-default border-v2-border-default shadow-input w-94 rounded-surface mx-auto flex flex-col border",
        className
      )}
    >
      {children}
    </div>
  )
}

export function StepCardTitle({ children }: { children: ReactNode }) {
  return (
    <h1 className="color-default text-title-lg border-v2-border-default w-full border-b px-6 py-5 text-left">
      {children}
    </h1>
  )
}

export function StepCardBody({
  className,
  children,
}: {
  className?: string
  children: ReactNode
}) {
  return (
    <div className={classNames("flex flex-col p-6", className)}>{children}</div>
  )
}

export function StepCardFooter({
  className,
  children,
}: {
  className?: string
  children: ReactNode
}) {
  return (
    <div
      className={classNames(
        "border-v2-border-default mx-6 border-t py-6",
        className
      )}
    >
      {children}
    </div>
  )
}
